export const comments = {
    "history": "Historial de comentarios",
    "comments": "Comentarios",
    "apartments": "Lista de apartamentos",
    "you": "Tú",
    "writeComment": "Escribir un comentario",
    "add": "Añadir un comentario",
    "manager": "Administrador",
    "bllink": "Bllink",
    "empty": "No hay comentarios para el apartamento"
};
